import { Alert } from 'antd';
import React from 'react';
import { useForgot } from 'utils/hooks/useLogin';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import LoginForm from './components/LoginForm';

import styles from './styles.module.css';

const { UserName, Submit } = LoginForm;

const LoginMessage = ({ content, type = 'error' }) => (
  <Alert style={{ marginBottom: 24 }} message={content} type={type} showIcon />
);
LoginMessage.propTypes = {
  content: PropTypes.string,
  type: PropTypes.string,
};

const Forgot = () => {
  const { forgotPassword, submitting, message, success } = useForgot();
  const handleSubmit = (values) => {
    forgotPassword(values);
  };

  return (
    <div className={styles.main}>
      <LoginForm onSubmit={handleSubmit}>
        {message && !submitting && <LoginMessage content={message} />}
        {success && !submitting && <LoginMessage content="Reset password link is sent to your email!" type="success" />}
        <UserName
          name="username"
          placeholder="ユーザー名"
          rules={[
            {
              required: true,
            },
          ]}
        />
        <div className={styles.pullRight}>
          <Link to="/login">すでにアカウントを持っている方</Link>
        </div>
        <Submit loading={submitting}>送信</Submit>
      </LoginForm>
    </div>
  );
};

export default Forgot;
